<div class="po-common-fields">
    <hr class="mt-2 mb-3" />
    <h6 class="form-section-title">Line Item Details</h6>
    <div class="row">
        <div class="col-12 form-group">
            <label for="lineDescription">Description</label>
            <input type="text" class="form-control" [(ngModel)]="item().description" name="lineDescription" id="lineDescription" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="glCo">GL Co</label>
            <input type="number" class="form-control" [(ngModel)]="item().glCo" name="glCo" id="glCo" />
        </div>
        <div class="col-sm-5 col-6 form-group">
            <label for="glAccount">GL Account</label>
            <input
                type="text"
                class="form-control"
                [(ngModel)]="item().glAccount"
                name="glAccount"
                id="glAccount"
                [readonly]="glAccountReadonly()"
            />
        </div>
        <div class="col-sm-4 col-12 form-group">
            <label for="glAccountDesc">Account Description</label>
            <input type="text" class="form-control-plaintext" [value]="item().glAccountDescription" id="glAccountDesc" readonly />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="reqDate">Req Date</label>
            <wj-input-date [(ngModel)]="item().reqDate" name="reqDate" id="reqDate" [isRequired]="false"></wj-input-date>
        </div>
    </div>

    <h6 class="form-section-title mt-3">Original</h6>
    <div class="row">
        <div class="col-sm-2 col-4 form-group">
            <label for="um">UM</label>
            <input type="text" class="form-control" [(ngModel)]="item().um" name="um" id="um" />
        </div>
        <div class="col-sm-3 col-4 form-group">
            <label for="units">Units</label>
            <input type="number" class="form-control" [(ngModel)]="item().units" name="units" id="units" step="0.001" />
        </div>
        <div class="col-sm-3 col-4 form-group">
            <label for="unitCost">UC</label>
            <input type="number" class="form-control" [(ngModel)]="item().unitCost" name="unitCost" id="unitCost" step="0.00001" />
        </div>
        <div class="col-sm-4 col-12 form-group">
            <label for="total">Total</label>
            <input type="text" class="form-control-plaintext" [value]="item().total | number:'1.2-2'" id="total" readonly />
        </div>
    </div>

    <h6 class="form-section-title mt-3">Tax</h6>
    <div class="row">
        <div class="col-sm-3 col-4 form-group">
            <label for="taxType">Type</label>
            <select class="form-control" [(ngModel)]="item().taxType" name="taxType" id="taxType">
                @for (opt of taxTypeOptions; track opt) {
                    <option [value]="opt">{{ opt || '(none)' }}</option>
                }
            </select>
        </div>
        <div class="col-sm-4 col-4 form-group">
            <label for="taxCode">Tax Code</label>
            <input type="text" class="form-control" [(ngModel)]="item().taxCode" name="taxCode" id="taxCode" />
        </div>
        <div class="col-sm-3 col-4 form-group">
            <label for="taxRate">Tax Rate</label>
            <input type="number" class="form-control" [(ngModel)]="item().taxRate" name="taxRate" id="taxRate" step="0.000001" />
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 col-12 form-group">
            <label for="supplier">Supplier</label>
            <input type="text" class="form-control" [(ngModel)]="item().supplier" name="supplier" id="supplier" />
        </div>
    </div>
</div>
